// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { IdentityProvider } from "./IdentityProvider";
import {
  IdentityProviderFromJSON,
  IdentityProviderFromJSONTyped,
  IdentityProviderToJSON,
  IdentityProviderToJSONTyped,
} from "./IdentityProvider";

/**
 *
 * @export
 * @interface PageIdentityProvider
 */
export interface PageIdentityProvider {
  /**
   *
   */
  total: number;
  /**
   *
   */
  items: Array<IdentityProvider>;
  /**
   *
   */
  limit?: number | null;
  /**
   *
   */
  offset?: number | null;
}

/**
 * Check if a given object implements the PageIdentityProvider interface.
 */
export function instanceOfPageIdentityProvider(value: object): value is PageIdentityProvider {
  if (!("total" in value) || value["total"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function PageIdentityProviderFromJSON(json: any): PageIdentityProvider {
  return PageIdentityProviderFromJSONTyped(json, false);
}

export function PageIdentityProviderFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PageIdentityProvider {
  if (json == null) {
    return json;
  }
  return {
    total: json["total"],
    items: (json["items"] as Array<any>).map(IdentityProviderFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
  };
}

export function PageIdentityProviderToJSON(json: any): PageIdentityProvider {
  return PageIdentityProviderToJSONTyped(json, false);
}

export function PageIdentityProviderToJSONTyped(
  value?: PageIdentityProvider | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    total: value["total"],
    items: (value["items"] as Array<any>).map(IdentityProviderToJSON),
    limit: value["limit"],
    offset: value["offset"],
  };
}
